import { OrderDoc, ProductDoc } from '@gooduncles/gu-app-schema';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RootState } from '../store';

export interface OrderState {
  submitted: OrderDoc | null;
  accepted: OrderDoc[];
  delivered: OrderDoc[];
  canceled: OrderDoc[];
  rejected: OrderDoc[];
  /**
   * UI에서 상품의 수량 표기 시 주문서와 장바구니 중 어떤 정보를 기준으로 할지 결정한다.
   */
  onEditOrder: boolean;
  orderCardOpen: boolean;
}

const initialState: OrderState = {
  submitted: null,
  accepted: [],
  delivered: [],
  canceled: [],
  rejected: [],
  onEditOrder: false,
  orderCardOpen: false,
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    clearOrder: () => initialState,
    setSubmittedOrder: (state, action: PayloadAction<OrderDoc | null>) => {
      state.submitted = action.payload;
    },
    setOrderHistory: (
      state,
      action: PayloadAction<Pick<OrderState, 'accepted' | 'delivered' | 'canceled' | 'rejected'>>
    ) => {
      state.accepted = action.payload.accepted;
      state.delivered = action.payload.delivered;
      state.canceled = action.payload.canceled;
      state.rejected = action.payload.rejected;
    },
    setOnEditOrder: (state, action: PayloadAction<boolean>) => {
      state.onEditOrder = action.payload;
    },
    setOrderCardOpen: (state, action: PayloadAction<boolean>) => {
      state.orderCardOpen = action.payload;
    },
  },
});

export const selectSubmiited = (state: RootState) => state.order.submitted;
export const selectAccepted = (state: RootState) => state.order.accepted;
export const selectDelivered = (state: RootState) => state.order.delivered;
export const selectCanceled = (state: RootState) => state.order.canceled;
export const selectRejected = (state: RootState) => state.order.rejected;
export const selectOnEditOrder = (state: RootState) => {
  return state.order.submitted === null ? null : state.order.onEditOrder;
};
export const selectOrderCardOpen = (state: RootState) => state.order.orderCardOpen;
export const selectOrderProductVolume = (state: RootState, productId: ProductDoc['_id']) => {
  const product = state.order.submitted?.products.find((p) => p.productId === productId);
  return product ? product.volume : 0;
};
export const selectOrdersForHistory = (state: RootState) => {
  const accepted = state.order.accepted;
  const delivered = state.order.delivered;
  const rejected = state.order.rejected;

  return [...accepted, ...delivered, ...rejected];
};

export const { clearOrder, setSubmittedOrder, setOrderHistory, setOrderCardOpen, setOnEditOrder } = orderSlice.actions;

export default orderSlice.reducer;
